module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dIfRq"))).then(() => parcelRequire('1iHdE'));